import { render } from "./IncidentsTable.vue?vue&type=template&id=36beb3ae&scoped=true"
import script from "./IncidentsTable.vue?vue&type=script&lang=js"
export * from "./IncidentsTable.vue?vue&type=script&lang=js"

import "./IncidentsTable.vue?vue&type=style&index=0&id=36beb3ae&lang=scss"
import "./IncidentsTable.vue?vue&type=style&index=1&id=36beb3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36beb3ae"]])

export default __exports__